import React from 'react';
import { Row, Col } from 'antd';
import { NavLink, useLocation } from 'react-router-dom';
import { 
  FacebookFilled, 
  InstagramOutlined, 
  YoutubeFilled, 
  LinkedinFilled 
} from '@ant-design/icons';
import '../css/Footer.css';

const Footer = () => {
  const location = useLocation();
  const isEnglish = location.pathname.startsWith('/en');
  const prefix = isEnglish ? '/en' : '';

  return (
    <footer className="footer-section">
      <div className="container-wide">
        <Row gutter={[40, 40]} className="footer-row">
          {/* 左側：品牌資訊 */}
          <Col xs={24} md={10} className="footer-col-info">
            <div className="footer-brand">
              <div className="big-title-ch mb-20">TANG WU</div>
              <div className="title-en big-title-en mb-20">TANG WU</div>
            </div>
            <div className="content-ch mb-10">
              致力於提供最高品質的食品原料，<br />
              成為您最信賴的合作夥伴。
            </div>
            <div className="content-en">
              Committed to delivering premium food ingredients <br /> and being your most trusted partner.
            </div>
          </Col>

          {/* 中間：快速連結 */}
          <Col xs={24} md={6} className="footer-col-links">
            <div className="footer-title">
              <span className="title-en">Quick Links</span>
            </div>
            <ul className="footer-links-list">
              <li>
                <NavLink to={`${prefix}/about`}>
                  <span className="content-ch">關於我們</span>
                  <span className="content-en ml-10">About us</span>
                </NavLink>
              </li>
              <li>
                <NavLink to={`${prefix}/advantages`}>
                  <span className="content-ch">製造優勢</span>
                  <span className="content-en ml-10">Advantages</span>
                </NavLink>
              </li>
              <li>
                <NavLink to={`${prefix}/product`}>
                  <span className="content-ch">產品介紹</span>
                  <span className="content-en ml-10">Products</span>
                </NavLink>
              </li>
              <li>
                <NavLink to={`${prefix}/news`}>
                  <span className="content-ch">最新消息</span>
                  <span className="content-en ml-10">News</span>
                </NavLink>
              </li>
              <li>
                <NavLink to={`${prefix}/contact`}>
                  <span className="content-ch">聯繫我們</span>
                  <span className="content-en ml-10">Contact us</span>
                </NavLink>
              </li>
            </ul>
          </Col>

          {/* 右側：社交媒體與聯繫 */}
          <Col xs={24} md={6} className="footer-col-social">
            <div className="footer-title">
              <span className="title-en">Follow Us</span>
            </div>
            <div className="social-icons">
              <a href="https://www.facebook.com/share/1C9wRk7y2C/?mibextid=wwXIfr" target="_blank" rel="noreferrer"><FacebookFilled /></a>
              <a href="https://www.instagram.com/tangwell?igsh=MWFqMHc0djI2NDBxYg==" target="_blank" rel="noreferrer"><InstagramOutlined /></a>
              <a href="https://www.youtube.com/@%E6%B9%AF%E6%AD%A6-e8w" target="_blank" rel="noreferrer"><YoutubeFilled /></a>
            </div>
            <div className='contact-info contact-email content-en'>
              <span className='contact-label'>Tax ID:</span>
              <div className='contact-values'>
                <span>53271157</span>
              </div>
            </div>
            <div className='contact-info contact-email content-en'>
              <span className='contact-label'>Email:</span>
              <div className='contact-values'>
                <span>tangwell@tangwell.com.tw</span>
                <span>tangwell.tw@gmail.com</span>
              </div>
            </div>
            <div className='contact-info contact-tel content-en'>
              <span className='contact-label'>Tel:</span>
              <div className='contact-values'>
                <span>+886-4-7977288 (Factory)</span>
                <span>+886-4-7270089 (Admin)</span>
              </div>
            </div>
            <div className='contact-info contact-tel content-en'>
              <span className='contact-label'>Fax:</span>
              <div className='contact-values'>
                <span>+886-4-7977289</span>
              </div>
            </div>
          </Col>
        </Row> 

        <div className="footer-bottom">
          <div className="copyright content-en">© 2026 TANG WU BIOTECHNOLOGY CO., LTD. All Rights Reserved.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;